const messages = {};

export default messages;
